import { FagomradeType } from '../types/minhelseentities';
import type { HNVerktoyFrontend } from '../types/Resources';
import type { CategoryCard } from '../types/types';

import BandAid from '@helsenorge/designsystem-react/components/Icons/BandAid';
import Heart from '@helsenorge/designsystem-react/components/Icons/Heart';
import HelpingHand from '@helsenorge/designsystem-react/components/Icons/HelpingHand';
import Hiker from '@helsenorge/designsystem-react/components/Icons/Hiker';
import MentalHealthAdult from '@helsenorge/designsystem-react/components/Icons/MentalHealthAdult';
import Pregnant from '@helsenorge/designsystem-react/components/Icons/Pregnant';

export const getCategoryCards = (resources?: HNVerktoyFrontend): CategoryCard[] => {
  const categoryCards: CategoryCard[] = [
    {
      category: FagomradeType.LIVSSTIL_OG_TRENING,
      title: resources?.fagomrade_livsstilOgTrening,
      icon: Hiker,
    },
    {
      category: FagomradeType.TANKER_OG_FOLELSER,
      title: resources?.fagomrade_tankerOgFolelser,
      icon: Heart,
    },
    {
      category: FagomradeType.GRAVIDITET_OG_FODSEL,
      title: resources?.fagomrade_graviditetOgFodsel,
      icon: Pregnant,
    },
    {
      category: FagomradeType.RAAD_OG_TIPS_I_HVERDAGEN,
      title: resources?.fagomrade_raadOgTipsIHverdagen,
      icon: HelpingHand,
    },
    {
      category: FagomradeType.SYKDOM_OG_SKADER,
      title: resources?.fagomrade_sykdomOgSkader,
      icon: BandAid,
    },
    {
      category: FagomradeType.PSYKISK_HELSE,
      title: resources?.fagomrade_psykiskHelse,
      icon: MentalHealthAdult,
    },
  ];
  return categoryCards;
};

export const getCategoryName = (fagomradeType: FagomradeType, resources?: HNVerktoyFrontend): string | undefined => {
  switch (fagomradeType) {
    case FagomradeType.LIVSSTIL_OG_TRENING:
      return resources?.fagomrade_livsstilOgTrening;
    case FagomradeType.TANKER_OG_FOLELSER:
      return resources?.fagomrade_tankerOgFolelser;
    case FagomradeType.GRAVIDITET_OG_FODSEL:
      return resources?.fagomrade_graviditetOgFodsel;
    case FagomradeType.RAAD_OG_TIPS_I_HVERDAGEN:
      return resources?.fagomrade_raadOgTipsIHverdagen;
    case FagomradeType.SYKDOM_OG_SKADER:
      return resources?.fagomrade_sykdomOgSkader;
    case FagomradeType.PSYKISK_HELSE:
      return resources?.fagomrade_psykiskHelse;
    default:
      return '';
  }
};
